import { QueryClient, useMutation, useQuery } from "@tanstack/react-query"

import clientSDK from "../../../App/ClientSDK"

import { PersonKnowledge } from "./PersonKnowledge"

type ApiKnowledge = {
    id: number
    uuid: string
    person_uuid: string
    activity_uuid: string
    is_active: boolean
    custom_duration: number
}

type ApiUpdateKnowledge = {
    activity_uuid: string,
    custom_duration: number,
    is_active: boolean
}

const baseUrl = 'hr/persons'

const getPersonKnowledge = async (uuid: string): Promise<PersonKnowledge[]> => {
    const response = await clientSDK
      .instance()
      .get<{ total: number, list:ApiKnowledge[]}>(`${baseUrl}/${uuid}/knowledge`)

      
      const data = response.data.list
        .map((knowledge) => ({
            uuid: knowledge.uuid,
            name: knowledge.activity_uuid,
            duration: knowledge.id,
            isActive: knowledge.is_active,
            customDuration: knowledge.custom_duration,
        }))
      return data
  }
  
  export const useGetPersonKnowledgeQuery = (uuid: string) => {
      return useQuery({
          queryKey: ['person-knowledge'],
          queryFn: () => getPersonKnowledge(uuid),
      })
  }


  const updatePersonKnowledge = async (knowledgeData: {uuid: string, knowledge: ApiUpdateKnowledge[]}) => {
    const response = await clientSDK
      .instance()
      .post<PersonKnowledge[]>(`${baseUrl}/${knowledgeData.uuid}/knowledge`, {person_activity_knowledge:knowledgeData.knowledge})
      console.log(response.data)
      return response
  }

  export const useUpdatePersonKnowledgeMutation = (queryClient: QueryClient) => {
    return useMutation({
        mutationFn: updatePersonKnowledge,
        onSettled: () => {
          queryClient.invalidateQueries({ queryKey: ['person-knowledge'] })
        },
      })
    }
